import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import AvatarEditPopup from './AvatarEditPopup';
import ChangeIcon from '@wix/da-shared-react/pkg/Icons/Change';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import s from './AvatarEdit.scss';

export interface Props {
  className?: string;
}

const defaultProps = {};

export interface State {
  isModalShown: boolean;
}
const defaultState = {
  isModalShown: false,
};

export class AvatarEdit extends React.Component<
  Props & WithTranslation,
  State
> {
  static defaultProps: Props = defaultProps;
  state: State = defaultState;
  render() {
    const { t } = this.props;
    return (
      <div className={s['root']}>
        <button onClick={this.showModal} data-role="edit-control">
          <ChangeIcon
            className={s['btn-icon']}
            size={IconSize.MEDIUM}
            condensed
          />
          <span className={s['btn-title']}>
            {t('common.change')}
            <VisuallyHidden>
              {t('widgets.avatarEdit.changeIconTitle')}
            </VisuallyHidden>
          </span>
        </button>
        <AvatarEditPopup
          isOpen={this.state.isModalShown}
          onRequestClose={this.hideModal}
        />
      </div>
    );
  }

  showModal = () => {
    this.setState({ isModalShown: true });
  };
  hideModal = () => {
    this.setState({ isModalShown: false });
  };
}

export default withTranslation()(AvatarEdit) as React.ComponentType<Props>;
